import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	add: {
		id: 'navigation-shortcuts.main.add-item.select-item-type-modal.content.type-selectors.common.type-selector.add',
		defaultMessage: 'Add',
		description: '',
	},
});
